import React, { useState}  from 'react'
import TextInput from './textInput'
import Currency from './currency'
import DogNumber from './dogNumber'
import HorseNumber from './horseNumber'

const BetsTable = ctx => {
  function toggleEwHelp(e) {
    e.preventDefault()
    setShowEwHelp(!showEwHelp)
  }
  const [showEwHelp, setShowEwHelp] = useState(false)
  const { placedBets, bets, validationErrors, handleChange, removeFromBettingSlip, placeBets } = ctx
  const typeSingular = ctx.meetType === 'horses' ? 'horse' : 'dog';
  return placedBets.concat(bets).length > 0 ? <div className="box">
              <h1 className="title">Bets</h1>
              <table className="table is-fullwidth">
                <thead>
                  <tr>
                    <td>
                      { ctx.meetType == 'horses' ? 'Horse' : 'Dog' }
                    </td>
                    <td>
                      Amount
                    </td>
                    <td>
                      <a href="#" onClick={toggleEwHelp}>Each Way</a>
                    </td>
                    <td>
                      Odds
                    </td>
                  </tr>
                </thead>
                <tbody>
                { placedBets.map((b, i) => {
                  return <React.Fragment key={`bets-${i}-1`}>
                    <tr className="joined-row-top">
                    <td className="dog">
                    { ctx.meetType == 'horses' ? <HorseNumber number={b.number} colorUrl={b.colorUrl} /> : <DogNumber number={b.number} color={b.color} /> }
                    </td>
                    <td>
                      <Currency amount={b.amount} />
                    </td>
                    <td>
                      { b.eachWay ? "Yup" : "Nope" }
                    </td>
                    <td>
                      { b.oddsAsFraction }
                    </td>
                  </tr>
                  <tr className="joined-row-bottom">
                    <td colSpan="4">
                      <strong className="is-pulled-right">Cost: <Currency amount={ b.amount && b.eachWay ? b.amount * 2 : b.amount } /></strong>
                      { b.winningsValue ? <span>
                        <strong className={ b.winningsValue > 0 ? 'has-text-success' : 'has-text-grey-light' }>Return: <Currency amount={ b.winningsValue } /></strong>
                        </span> : null}
                    </td>
                  </tr>
                </React.Fragment>
                })
                }
                { bets.map((b,i) => {
                  return <React.Fragment key={`bets-${i}-2`}>
                    <tr className="new-bet joined-row-top">
                    <td className="dog">
                       { ctx.meetType == 'horses' ? <HorseNumber number={b.number} colorUrl={b.colorUrl} /> : <DogNumber number={b.number} color={b.color} /> }
                    </td>
                    <td>
                      <div className="control">
                        <TextInput
                          numericKeypad={true}
                          validationErrors={validationErrors}
                          type="text"
                          onChange={(e) => handleChange(e,i)}
                          name="amount" />
                      </div>
                    </td>
                    <td>
                      <input type="checkbox" value={b.eachWay} name="eachWay" onChange={(e) => handleChange(e,i)} />
                    </td>
                    <td>
                      { b.oddsAsFraction}
                    </td>
                  </tr>
                  <tr className="joined-row-bottom">
                    <td colSpan="4">
                      <strong>Cost: <Currency amount={b.amount && b.eachWay ? b.amount * 2 : b.amount} /></strong>
                        <span className="is-pulled-right"><a href="#" title="Remove" onClick={(e) => removeFromBettingSlip(e, i) }>
                          <strong>remove</strong>
                        </a>
                      </span>
                    </td>
                  </tr>
                </React.Fragment>
                })}
                </tbody>
              </table>
              { bets.length > 0 ? <button className="button is-success" onClick={placeBets}>Place bets</button> : null }
  
      <div className={showEwHelp ? "modal is-active" : "modal"}>
        <div className="modal-background"></div>
          <div className="modal-card">
          <header className="modal-card-head">
          <p className="modal-card-title">Each way bets</p>
          </header>
          <section className="modal-card-body">
            <p>
              An <strong>Each way</strong> bet, is a bet that the {typeSingular} will come first or second.
            </p><br />
            <p>
              If a {typeSingular} has an SP of 12/1, and you bet &pound;1 each way, your bet will cost &pound;2.
            </p><br />
            <p>
              If the {typeSingular} comes in second place, you will win at a quarter of the SP odds so you would get &pound;3 back + your &pound;1 stake.
            </p><br />
            <p>
              If the {typeSingular} comes in first place, you will win one bet at full SP odds (getting &pound;12 back), and one bet
              at a quarter of the SP odds (getting &pound;3 back) so in total you would win &pound;15 + your &pound;2 stake.
            </p>
          </section>
          <footer className="modal-card-foot">
          <button onClick={toggleEwHelp} className="button">Close</button>
          </footer>
        </div>
      </div>
    <style jsx>{`
       .joined-row-top td{
         border-bottom:0;
       }
       .joined-row-bottom td{
         border-top:0;
         padding-bottom: 1em;
       }
      `}</style>
  </div> : null
}

export default BetsTable
